import i18n from "@/plugins/i18n"
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import { computed } from "vue";
import { licenseModules } from "@/composables/useLicense";

const shopGroup = ['shop-index', 'shop-view', 'shop-products' , 'entering-storage', 'stock-transfer', 'stock-transfer-create', 'agents',  'shop-users', 'shop-boxes', 'sales', 'shop-sales', 'shop-store-config']
const shopStatsGroup = ['shop-statistic', 'shop-statistic-sales', 'shop-statistic-categories', 'shop-statistic-customer']
const shopStatsSalesGroup = ['shop-statistic-sales']
const shopStatsCategoriesGroup = ['shop-statistic-categories']
const shopStatsCustomerGroup = ['shop-statistic-customer']
const warehouseGroup = ['shop-warehouse', 'shop-warehouse-view', 'shop-store-products', 'shop-store-users', 'shop-store-entries', 'shop-store-entry-create', 'shop-store-entry-transfer']
const saleSessionsGroup = ['shop-sales-sessions','new-session','sessions-details','sessions-sales','sessions-products']
const stateGroup = ['stock-status']
const stockStatusGroup = ['stock-status']


export default {
    menus: computed(() => ([
        {
            sectionTitle: i18n.global.t('menu.sections.shop'),
            module: '',
            permission: abilities.SHOP.VIEW,
            teamScope: 'shop',
            children: [
                {
                    title: i18n.global.t('menu.shop.list'),
                    icon: 'fas fa-store icon-right2',
                    route: 'shop-index',
                    group: shopGroup,
                    id: 'step-shops',
                    permission: [abilities.SHOP.VIEW],
                    teamScope: 'shop',
                    children: [],
                    module: [moduleAbilities.SHOP_LITE ,moduleAbilities.SHOP_MINI],
                },
                {
                    title: i18n.global.t('menu.warehouses'),
                    module : [moduleAbilities.STORE],
                    icon: 'fas fa-warehouse',
                    route: 'shop-warehouse',
                    group: warehouseGroup,
                    id: 'step-warehouse',
                    permission: [abilities.STORE.VIEW],
                    teamScope: 'store',
                    license: licenseModules.WAREHOUSES,
                    children: [],
                },
                {
                    title: 'POS',
                    module : [moduleAbilities.POS],
                    icon: 'fas fa-calculator',
                    route: 'shop-sales-sessions',
                    group: saleSessionsGroup,
                    id: 'step-pos',
                    permission: [abilities.CAN_VIEW_SESSION_LIST],
                    teamScope: 'shop',
                    license: licenseModules.POS_SESSION_WEB,
                    children: [],
                },
            ]
        },
        {
            sectionTitle: i18n.global.t('menu.statistics'),
            module: moduleAbilities.STATISTIC_LITE,
            permission: [abilities.SHOP.VIEW],
            teamScope: 'shop',
            children: [
                {
                    title: i18n.global.t('menu.statistics'),
                    module: moduleAbilities.STATISTIC_LITE,
                    icon: 'fas fa-chart-line',
                    group: shopStatsGroup,
                    id: 'step-statistics',
                    permission: [abilities.SHOP.VIEW],
                    teamScope: 'shop',
                    children: [
                        {
                            title: i18n.global.t('menu.sales'),
                            icon: 'fas fa-chart-line',
                            route: 'shop-statistic-sales',
                            group: shopStatsSalesGroup,
                            id: 'step-stats-sales',
                            permission: [abilities.SHOP.VIEW],
                            teamScope: 'shop',
                            module: moduleAbilities.STATISTIC_LITE,
                            license: licenseModules.STAT_SALES_WEB
                        },
                        {
                            title: i18n.global.t('menu.categories'),
                            icon: 'fas fa-chart-line',
                            route: 'shop-statistic-categories',
                            group: shopStatsCategoriesGroup,
                            id: 'step-stats-categories',
                            permission: [abilities.SHOP.VIEW],
                            teamScope: 'shop',
                            module: moduleAbilities.STATISTIC_LITE,
                            license: licenseModules.STAT_CATEGORIES_WEB
                        },
                        {
                            title: i18n.global.t('menu.customer'),
                            icon: 'fas fa-chart-line',
                            route: 'shop-statistic-customer',
                            group: shopStatsCustomerGroup,
                            id: 'step-stats-customer',
                            permission: [abilities.SHOP.VIEW],
                            teamScope: 'shop',
                            module: moduleAbilities.STATISTIC_LITE,
                            license: licenseModules.STAT_CUSTOMERS_WEB
                        }
                    ],
                },
                {
                    title: i18n.global.t('menu.state'),
                    module:  [],
                    icon: 'fas fa-file-alt',
                    group: stateGroup,
                    id: 'step-state',
                    permission: [],
                    teamScope: 'shop',
                    children: [
                        {
                            title: i18n.global.t('menu.stock'),
                            module : [],
                            icon: 'fas fa-clipboard-list',
                            route: 'stock-status',
                            group: stockStatusGroup,
                            id: 'step-state-stock',
                            permission: [],
                            teamScope: 'shop',
                            license: licenseModules.STOCK_STATUS_WEB,
                        },
                    ]
                },
            ],
        },
    ]))
}
